import { collection, addDoc } from '@firebase/firestore';
import { db } from '../firebase';

export const setError = async (user, message) => {
  return await addDoc(collection(db, 'errors'), {
    user: user,
    message,
    date: new Date().toISOString(),
  });
};
